import React, { useState } from "react";

const ConnectWalletPopup = ({
  showPopup,
  setShowPopup,
  setShowTemplePopup,
}) => {
  if (!showPopup) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Connect Wallet</h2>
        <p>
          If you don’t have a wallet, you can select a provider and create one.
        </p>

        <span
          className="box-url left p-3"
          onClick={(e) => {
            setShowTemplePopup(true);
            setShowPopup(false);
          }}
        >
          <span className="box-url-label">Most Popular</span>
          <img src="./img/wallet/templewallet.png" alt="" className="mb20" />
          <h4>Temple Wallet</h4>
          <p>
            A user-friendly wallet for interacting with the Tezos blockchain.
            Secure, versatile, and trusted by the Tezos community worldwide.
          </p>

          {/* Connect Wallet Button */}
        </span>
        <button className="close-btn" onClick={() => setShowPopup(false)}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ConnectWalletPopup;
